import { api } from '@kolab/dms-base/api'
import type {
  AllocateResellerLicenseRequest,
  PageableQuery,
  PaginatedResponse,
  ResellerLicense,
  SetResellerLicenseStatusRequest,
  UpdateResellerLicenseLimitRequest,
} from './types'

const BASE = '/v1/reseller-licenses'

export interface ListResellerLicensesQuery extends PageableQuery {
  resellerId?: string
  distributorLicenseId?: string
}

export async function listResellerLicenses(params?: ListResellerLicensesQuery) {
  return api.get<PaginatedResponse<ResellerLicense>>(BASE, { params, _suppressErrorToast: true }).then((r) => r.data)
}

export async function getResellerLicense(id: string) {
  return api.get<ResellerLicense>(`${BASE}/${id}`).then((r) => r.data)
}

export async function allocateResellerLicense(payload: AllocateResellerLicenseRequest) {
  return api.post<ResellerLicense>(BASE, payload).then((r) => r.data)
}

export async function updateResellerLicenseLimit(id: string, payload: UpdateResellerLicenseLimitRequest) {
  return api.put<ResellerLicense>(`${BASE}/${id}/limit`, payload).then((r) => r.data)
}

export async function setResellerLicenseStatus(id: string, payload: SetResellerLicenseStatusRequest) {
  return api.put<ResellerLicense>(`${BASE}/${id}/status`, payload).then((r) => r.data)
}
